import List from 'components/list/list';
import React, { useState } from 'react';
import { useIntl } from 'react-intl';
import ListCalibrationRow from 'views/bluviu-nutrition/features/calibrations/components/list-calibration-row';
import { CalibrationListItem } from '../types/calibration-list-item.type';
import Pagination from 'components/pagination';
import { usePagination } from 'hooks/use-pagination';

type Props = {
  calibrations: CalibrationListItem[];
  setCalibrations: React.Dispatch<React.SetStateAction<CalibrationListItem[]>>;
};

const PAGE_NAME_ID = `bluViuNutrition.calibrations.listCalibrations`;

const ListCalibrations: React.FC<Props> = ({ calibrations, setCalibrations }) => {
  const intl = useIntl();
  const PAGINATION_LIMIT = 10;
  const { currentPage, from, to, handlePagination } = usePagination(PAGINATION_LIMIT);

  return (
    <>
      <List
        noResult={{
          show: !calibrations.length,
          text: intl.formatMessage({ id: `general.noResults` }),
        }}
        orderBy={'calibratedAt'}
        rows={calibrations}
        sort={setCalibrations}
        options={[
          { id: 'name', label: intl.formatMessage({ id: `${PAGE_NAME_ID}.list.name` }) },
          { id: 'model', label: intl.formatMessage({ id: `${PAGE_NAME_ID}.list.model` }) },
          { id: 'calibratedAt', label: intl.formatMessage({ id: `${PAGE_NAME_ID}.list.calibratedAt` }) },
          { id: 'state', label: intl.formatMessage({ id: `${PAGE_NAME_ID}.list.state` }) },
          { id: 'actions', label: '' },
        ]}>
        {calibrations.slice(from, to).map((calibration, idx) => {
          return <ListCalibrationRow calibration={calibration} key={calibration.id} />;
        })}
      </List>
      <Pagination
        currentPage={currentPage}
        pages={Math.ceil(calibrations.length / PAGINATION_LIMIT)}
        onClick={handlePagination}
      />
    </>
  );
};

export default React.memo(ListCalibrations);
